import { Grid } from "@mui/material";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  convertBase64,
  getItem,
  setItem,
} from "../../../helpers/data_management";
import { getDropResumeFile } from "../../../helpers/homepage_drop_resume";
import { updateHomepageReplaceResumeDialog } from "../../../redux/actions/dialog_action";
import { newResumeUpload } from "../../../redux/actions/user_action";
import * as types from "../../../redux/types/user_type";
import {
  CancelButton,
  CloseIcon,
  ContentContainer,
  ContentText,
  DialogContent,
  DialogFooter,
  DialogHeader,
  ExclaimationIcon,
  HeaderContainer,
  ReplaceButton,
  StyledDialog,
  StyledErrorCircle,
  StyledTitle,
  TitleContainer,
  ToastContentContainer,
  ToastContentText,
  ToastTitle,
  ToastTitleContainer,
} from "./styles";

export default function HomepageDropResume(props) {
  const {
    userResume,
    setUserResume,
    triggerToast,
    onCloseModal,
    onFlowComplete,
  } = props;

  const router = useRouter();
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const dialogStatus = useSelector(
    (state) => state.dialog?.showHomepageReplaceResumeDialog
  );

  const pdpaRequested = useSelector(
    (state) => state.user.pdpaDialogRequested
  );

  function ShowSalaryDialog(user) {
    const userId = user?.id;
    const dontShow = localStorage.getItem(
      `currentSalaryDialogDontShow_${userId}`
    );
    if (userId && !user?.currentSalary && !dontShow) {
      localStorage.setItem("showCurrentSalaryDialogAfterJump", "1");

      return true;
    }
    return false;
  }

  function handleClose() {
    dispatch(updateHomepageReplaceResumeDialog(false));

    if (onCloseModal) {
      onCloseModal();
      return;
    }

    router.push("/jobs");
  }

  function handleUploadSuccess(response) {
    setItem("HOMEPAGE-RESUME-UPLOADED", true);
    setItem(types.USER_PROFILE, JSON.stringify(response.user));

    if (onFlowComplete) {
      dispatch(updateHomepageReplaceResumeDialog(false));
      onFlowComplete(response);
      return;
    }

    ShowSalaryDialog(response.user);
    handleClose();
  }

  async function handleSubmitResume(userResume) {
    const resumeFile = getDropResumeFile(userResume);
    if (resumeFile) {
      convertBase64(resumeFile).then((cvFile) => {
        // Trigger graphQL to upload cvFile
        let params = {
          resume: cvFile,
          resume_drop: true,
          canCancel: false,
          user_resume: "",
          origin: "homepage",
          first_time_upload_with_resume: true, // To determine if the user has already uploaded resume on onboarding/profile page and decide to submit resume via drop resume page
          autoGenerated: false,
        };

        dispatch(newResumeUpload(params)).then((response) => {
          if (response.type === types.UPDATE_USER_CV_SUCCEED) {
            handleUploadSuccess(response);
          } else {
            triggerToast(
              false,
              toastContent(t("homepage.resume_uploaded_resume_failed"))
            );
          }
        });
      });
    } else {
      const localStorageTempResume = JSON.parse(getItem("TEMP_RESUME_BASE64"));

      let params = {
        resume: localStorageTempResume,
        resume_drop: true,
        canCancel: false,
        user_resume: "",
        origin: "homepage",
        first_time_upload_with_resume: true, // To determine if the user has already uploaded resume on onboarding/profile page and decide to submit resume via drop resume page
        autoGenerated: false,
      };

      dispatch(newResumeUpload(params)).then((response) => {
        if (response.type === types.UPDATE_USER_CV_SUCCEED) {
          localStorage.removeItem("TEMP_RESUME_BASE64");
          handleUploadSuccess(response);
        } else {
          triggerToast(
            false,
            toastContent(t("homepage.resume_uploaded_resume_failed"))
          );
        }
      });
    }
  }

  function toastContent(message) {
    return (
      <Grid>
        <ToastTitleContainer>
          <StyledErrorCircle />
          <ToastTitle>{t("homepage.error_title")}</ToastTitle>
        </ToastTitleContainer>
        <ToastContentContainer>
          <ToastContentText>{message}</ToastContentText>
        </ToastContentContainer>
      </Grid>
    );
  }

  return (
    <StyledDialog open={dialogStatus && !pdpaRequested}>
      <DialogHeader>
        <HeaderContainer>
          <TitleContainer>
            <ExclaimationIcon />
            <StyledTitle>{t("homepage.resume_replace_title")}</StyledTitle>
          </TitleContainer>
          <CloseIcon
            onClick={() => {
              dispatch(updateHomepageReplaceResumeDialog(false));
            }}
          />
        </HeaderContainer>
      </DialogHeader>
      <DialogContent>
        <ContentContainer>
          <ContentText>{t("homepage.resume_replace_message")}</ContentText>
        </ContentContainer>
      </DialogContent>
      <DialogFooter>
        <CancelButton onClick={handleClose}>
          {t("homepage.resume_replace_cancel")}
        </CancelButton>
        <ReplaceButton
          onClick={() => {
            handleSubmitResume(userResume);
          }}
        >
          {t("homepage.resume_replace_button")}
        </ReplaceButton>
      </DialogFooter>
    </StyledDialog>
  );
}
